import { Link } from "react-router-dom";
import useUIStyles from "../../../Hooks/useUIStyles";

function BlogPost({ post }) {
  const { heading, title, description } = useUIStyles();

  return <div className=" group border rounded-xl overflow-hidden p-4 hover:shadow  cursor-pointer ">
    <div className="flex flex-col md:flex-row gap-4">
      <div className="md:w-2/5 bg-neutral-100">
        <img src={post.imageUrl || "/placeholder.svg"} alt={post.imageAlt} className="rounded-lg object-cover h-full w-full transition-transform duration-300 group-hover:scale-105" />
      </div>
      <div className="md:w-3/5">
        <h2 className="text-xl font-medium text-[#3d3d3d] mb-2" style={{ ...title }}>
          {post.title}
        </h2>
        <p className="text-sm text-[#5a5a5a] mb-4" style={{ ...description }}>
          {post.excerpt}
        </p>
        <Link to="#" className="text-[#3d3d3d] font-medium hover:underline hover:text-red-300">
          Read More
        </Link>
      </div>
    </div>
  </div>;
}

export default BlogPost;
